<template>
  <UIFilter
    v-model="clearedFilter"
    v-model:storage="filterStorage"
    :fields="filterFields"
    :readonly
    placement="bottom-end"
  >
    <template #default="{ count, handleToggle, handleClear }">
      <DSButtonIndicator
        variant="secondary"
        :size="isMobile ? 'icon-sm' : 'sm'"
        :indicator="(count ?? 0) > 0"
        :readonly
        clearable
        @click="handleToggle"
        @click:clear="handleClear"
      >
        <FunnelIcon />
        <template v-if="!isMobile">
          Filter
        </template>
      </DSButtonIndicator>
    </template>
  </UIFilter>
</template>

<script setup lang="ts">
import { provide } from 'vue'

import { Filter, FilterField } from '@types'

import { UIFilter } from '@ui/controllers'
import { DSButtonIndicator } from '@ds'
import { FunnelIcon } from '@lucide/vue'

interface PivotFilterControlProps {
  filterFields: FilterField[]
  readonly?: boolean
  isMobile?: boolean
}

defineProps<PivotFilterControlProps>()

const clearedFilter = defineModel<Filter>('cleared-filter')
const filterStorage = defineModel<Filter>('filter-storage')
  
// TODO: remove this after replace old filter components
provide('size', undefined)
</script>
